import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import React from "react";

import { removeSpace } from "../../../system";
import {
  Directions,
  leaderboardConstants,
  translationConstants,
} from "../../../constants";
import {
  MedalBronzeIcon,
  MedalGoldIcon,
  MedalSilverIcon,
  ProfilePlaceholder,
} from "../../../assets/images/icon";

const LeaderboardRankCard = (props) => {
  const { medal, userData, isLowerRanks = false } = props;

  const { t } = useTranslation();

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const getMedalLogo = () => {
    if (medal == leaderboardConstants.GOLD_MEDAL) {
      return MedalGoldIcon;
    }
    if (medal == leaderboardConstants.SILVER_MEDAL) {
      return MedalSilverIcon;
    }
    if (medal == leaderboardConstants.BRONZE_MEDAL) {
      return MedalBronzeIcon;
    }
  };

  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  return (
    <div
      className={`rank-card 
        ${medal == leaderboardConstants.GOLD_MEDAL ? "gold-color" : ""}
        ${medal == leaderboardConstants.SILVER_MEDAL ? "silver-color" : ""}
        ${medal == leaderboardConstants.BRONZE_MEDAL ? "bronze-color" : ""}
        ${isLowerRanks ? "my-2" : "my-3"}
        d-flex leaderboard align-items-center`}
    >
      <div
        className={`col-1 col-xs-2 text-center align-items-center d-flex justify-content-center ${
          isLowerRanks ? "w-rank" : ""
        }`}
      >
        <span
          className={`second-card-heading-text fs-24 ${
            isLowerRanks ? "text-green" : "text-white"
          }`}
        >
          {userData?.rank}
        </span>
      </div>

      {medal && (
        <div className="col-1 d-flex justify-content-center align-items-center">
          <img src={getMedalLogo()} alt="gold_logo" />
        </div>
      )}

      <div
        className={`col-2 text-center ${
          isLowerRanks ? "rank-below" : "rank-top"
        } ${isLowerRanks ? "w-image" : ""} `}
      >
        <img
          className="rounded-circle img-size-45"
          src={
            userData?.profilePicture?.link
              ? userData?.profilePicture?.link
              : ProfilePlaceholder
          }
          alt="center-logo"
        />
      </div>

      <div
        className={`col-3 d-flex align-items-center ${
          isLowerRanks ? "col-sm-4" : "col-sm-3"
        } ${isLowerRanks ? "w-name" : ""}`}
      >
        <span
          className={`${
            isMobile ? "font-14" : "font-16"
          } fw-bolder leaderboard-text w-75`}
        >
          {direction === Directions.rtl && removeSpace(userData?.arabicName)
            ? userData?.arabicName
            : userData?.name}
        </span>
      </div>

      <div className="col-2 col-sm-1 d-flex align-items-center">
        <span
          className={`${
            isMobile ? "font-14" : "font-16"
          } fw-medium leaderboard-text`}
        >
          {userData?.participantAge <= process.env.REACT_APP_YOUTH_ONLY_AGE &&
            `Y-${userData?.participantAge}`}
        </span>
      </div>

      <div
        className={`col-3 col-sm-2 d-flex align-items-center justify-content-end ${
          isLowerRanks ? "w-points" : ""
        } ${direction === Directions.rtl ? "ps-2" : "pe-2"}
        `}
      >
        <span
          className={`${
            isLowerRanks ? "text-green" : "text-white"
          } font-14 fw-500 leaderboard-text`}
        >
          {`${userData?.totalPoints} ${t(translationConstants.POINTS)}`}
        </span>
      </div>
    </div>
  );
};

export default LeaderboardRankCard;
